module.exports = __webpack_public_path__ + "img/数字化城市管理平台.e5fe8164.png";